<template>
  <ReleasesComponent />
</template>

<script>
import ReleasesComponent from "@/sections/voiceplus/components/ReleasesComponent.vue";
import config from "@/config";

export default {
  name: "Releases",
  components: { ReleasesComponent },
  data: function () {
    return {
      sections: config.Sites,
    };
  },
};
</script>

<style scoped>
.home {
  background-color: #ececec;
}
</style>
